import { render, staticRenderFns } from "./PlaceholderLoadingSkeleton.vue?vue&type=template&id=0474c234&scoped=true&"
import script from "./PlaceholderLoadingSkeleton.vue?vue&type=script&lang=js&"
export * from "./PlaceholderLoadingSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./PlaceholderLoadingSkeleton.vue?vue&type=style&index=0&id=0474c234&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0474c234",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0474c234')) {
      api.createRecord('0474c234', component.options)
    } else {
      api.reload('0474c234', component.options)
    }
    module.hot.accept("./PlaceholderLoadingSkeleton.vue?vue&type=template&id=0474c234&scoped=true&", function () {
      api.rerender('0474c234', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PlaceholderLoadingSkeleton.vue"
export default component.exports